import { FormBase } from 'core/components';

export default class BaasicTableSettingsForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'templateName',
					label: 'TEMPLATE.NAME',
					rules: 'required|string',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/common/forms/BaasicTableSettingsForm.js